module.exports = __webpack_public_path__ + "img/card_bologna_trafficlight_background.4eb2fd33.png";